import debounce from 'lodash/debounce';

const titleContext = { entityName: null, action: null, entityType: null };
let _router = null;
let _getDefaultTitle = () => '';

export function initTitleContext (router, { getDefaultTitle = () => '' } = {}) {
    _router = router;
    _getDefaultTitle = getDefaultTitle;
}

export const scheduleApplyTitle = debounce(() => {
    if (_router?.currentRoute?.value) {
        applyRouteTitle(_router.currentRoute.value);
    }
}, 10);

export function setTitleContext (context = {}) {
    if ('entityName' in context) titleContext.entityName = context.entityName;
    if ('action' in context) titleContext.action = context.action;
    if ('entityType' in context) titleContext.entityType = context.entityType;
    scheduleApplyTitle();
}

export function clearTitleContext () {
    titleContext.entityName = null;
    titleContext.action = null;
    titleContext.entityType = null;
}

export function resolveRouteTitle (route) {
    const metaTitle = route?.meta?.title;
    const title = typeof metaTitle === 'function' ? metaTitle(route) : metaTitle;

    return typeof title === 'string' ? title.trim() : '';
}

export function applyRouteTitle (to) {
    const { entityName, action, entityType: contextEntityType } = titleContext;
    const pageTitle = resolveRouteTitle(to);
    const entityType = contextEntityType ?? pageTitle;
    const base = [entityName, entityType].filter(Boolean).join(' - ');
    const titlePart = [action, base].filter(Boolean).join(' - ');

    document.title = titlePart || pageTitle || _getDefaultTitle();
}
